"use client";

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/Button';
import { ArrowRight, Play, Sparkles, TrendingUp, Award } from 'lucide-react';
export default function Hero() {
  const $ = _c(36);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      Icon: Sparkles,
      delay: 0,
      position: "top-20 left-10"
    }, {
      Icon: TrendingUp,
      delay: 0.2,
      position: "top-40 right-20"
    }, {
      Icon: Award,
      delay: 0.4,
      position: "bottom-40 left-20"
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const floatingIcons = t0;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute inset-0 overflow-hidden"><div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob" /><div className="absolute top-1/3 right-1/4 w-96 h-96 bg-purple-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000" /><div className="absolute bottom-1/4 left-1/3 w-96 h-96 bg-indigo-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000" /></div>;
    t2 = floatingIcons.map(_temp);
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0,
      x: -50
    };
    t4 = {
      opacity: 1,
      x: 0
    };
    t5 = {
      duration: 0.8
    };
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  let t7;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      opacity: 0,
      y: 20
    };
    t7 = {
      opacity: 1,
      y: 0
    };
    t8 = {
      delay: 0.2
    };
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <motion.div initial={t6} animate={t7} transition={t8} className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold mb-6"><Sparkles className="w-4 h-4" /><span>The Future of Career Development</span></motion.div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  let t11;
  let t12;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      opacity: 0,
      y: 20
    };
    t11 = {
      opacity: 1,
      y: 0
    };
    t12 = {
      delay: 0.3
    };
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
  } else {
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <motion.h1 initial={t10} animate={t11} transition={t12} className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-gray-900 leading-tight mb-6">Learn, Compete,<span className="block bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent">Get Hired</span></motion.h1>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <motion.p initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.4
    }} className="text-lg sm:text-xl text-gray-600 mb-8 max-w-2xl mx-auto lg:mx-0">Master in-demand skills with our courses, compete on leaderboards, and get automatically matched with real job opportunities. Your journey from learning to earning starts here.</motion.p>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  let t16;
  let t17;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      opacity: 0,
      y: 20
    };
    t16 = {
      opacity: 1,
      y: 0
    };
    t17 = {
      delay: 0.5
    };
    $[15] = t15;
    $[16] = t16;
    $[17] = t17;
  } else {
    t15 = $[15];
    t16 = $[16];
    t17 = $[17];
  }
  let t18;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Button size="xl" variant="default" className="group">Start Learning Free<ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" /></Button>;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <motion.div initial={t15} animate={t16} transition={t17} className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">{t18}<Button size="xl" variant="outline" className="group"><Play className="w-5 h-5" />Watch Demo</Button></motion.div>;
    $[19] = t19;
  } else {
    t19 = $[19];
  }
  let t20;
  let t21;
  let t22;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      opacity: 0,
      y: 20
    };
    t21 = {
      opacity: 1,
      y: 0
    };
    t22 = {
      delay: 0.6
    };
    $[20] = t20;
    $[21] = t21;
    $[22] = t22;
  } else {
    t20 = $[20];
    t21 = $[21];
    t22 = $[22];
  }
  let t23;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div className="text-center lg:text-left"><div className="text-3xl font-bold text-gray-900">10K+</div><div className="text-sm text-gray-600 mt-1">Active Students</div></div>;
    $[23] = t23;
  } else {
    t23 = $[23];
  }
  let t24;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className="text-center lg:text-left"><div className="text-3xl font-bold text-gray-900">500+</div><div className="text-sm text-gray-600 mt-1">Partner Companies</div></div>;
    $[24] = t24;
  } else {
    t24 = $[24];
  }
  let t25;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <motion.div initial={t3} animate={t4} transition={t5} className="text-center lg:text-left">{t9}{t13}{t14}{t19}<motion.div initial={t20} animate={t21} transition={t22} className="grid grid-cols-3 gap-6 mt-12 pt-8 border-t border-gray-200">{t23}{t24}<div className="text-center lg:text-left"><div className="text-3xl font-bold text-gray-900">95%</div><div className="text-sm text-gray-600 mt-1">Success Rate</div></div></motion.div></motion.div>;
    $[25] = t25;
  } else {
    t25 = $[25];
  }
  let t26;
  let t27;
  let t28;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = {
      opacity: 0,
      x: 50
    };
    t27 = {
      opacity: 1,
      x: 0
    };
    t28 = {
      duration: 0.8,
      delay: 0.2
    };
    $[26] = t26;
    $[27] = t27;
    $[28] = t28;
  } else {
    t26 = $[26];
    t27 = $[27];
    t28 = $[28];
  }
  let t29;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <div className="absolute inset-0 bg-grid-white/10" />;
    $[29] = t29;
  } else {
    t29 = $[29];
  }
  let t30;
  let t31;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = {
      y: [0, -10, 0]
    };
    t31 = {
      duration: 3,
      repeat: Infinity
    };
    $[30] = t30;
    $[31] = t31;
  } else {
    t30 = $[30];
    t31 = $[31];
  }
  let t32;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <motion.div animate={t30} transition={t31} className="absolute top-10 right-10 bg-white rounded-2xl p-6 shadow-xl max-w-xs"><div className="flex items-center gap-3 mb-3"><div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center"><Award className="w-6 h-6 text-green-600" /></div><div><div className="font-bold text-gray-900">Course Completed!</div><div className="text-sm text-gray-600">React Development</div></div></div><div className="text-xs text-gray-500">Certificate ready to download</div></motion.div>;
    $[32] = t32;
  } else {
    t32 = $[32];
  }
  let t33;
  let t34;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = {
      y: [0, 10, 0]
    };
    t34 = {
      duration: 3,
      repeat: Infinity,
      delay: 0.5
    };
    $[33] = t33;
    $[34] = t34;
  } else {
    t33 = $[33];
    t34 = $[34];
  }
  let t35;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">{t1}{t2}<div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 md:py-40"><div className="grid lg:grid-cols-2 gap-12 items-center">{t25}<motion.div initial={t26} animate={t27} transition={t28} className="relative hidden lg:block"><div className="relative"><div className="relative w-full h-[600px] rounded-3xl bg-gradient-to-br from-blue-500 via-indigo-500 to-purple-500 shadow-2xl overflow-hidden">{t29}{t32}<motion.div animate={t33} transition={t34} className="absolute bottom-10 left-10 bg-white rounded-2xl p-6 shadow-xl max-w-xs"><div className="flex items-center gap-3 mb-3"><div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center"><TrendingUp className="w-6 h-6 text-blue-600" /></div><div><div className="font-bold text-gray-900">New Match!</div><div className="text-sm text-gray-600">Frontend Internship</div></div></div><div className="text-xs text-gray-500">Based on your skills</div></motion.div></div></div></motion.div></div></div></section>;
    $[35] = t35;
  } else {
    t35 = $[35];
  }
  return t35;
}
function _temp(t0, index) {
  const {
    Icon,
    delay,
    position
  } = t0;
  return <motion.div key={index} className={`absolute ${position} hidden lg:block`} initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: [0.3, 0.6, 0.3],
    y: [0, -20, 0]
  }} transition={{
    duration: 3,
    delay,
    repeat: Infinity,
    ease: "easeInOut"
  }}><div className="bg-white/50 backdrop-blur-sm p-4 rounded-2xl shadow-lg"><Icon className="w-8 h-8 text-blue-600" /></div></motion.div>;
}